'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.923 3.5c2.74 0 4.968 2.238 4.968 4.99 0 2.657-2.078 4.835-4.688 4.981a4.372 4.372 0 0 0-.506 2.039c0 2.4 1.944 4.353 4.334 4.353 2.39 0 4.334-1.953 4.334-4.353a4.332 4.332 0 0 0-3.327-4.235l.147-.62A4.968 4.968 0 0 1 21 15.51c0 2.751-2.229 4.99-4.969 4.99-2.739 0-4.968-2.239-4.968-4.99 0-.81.198-1.607.571-2.319a4.345 4.345 0 0 0-3.666-2.034c-2.39 0-4.334 1.952-4.334 4.353 0 2.4 1.944 4.353 4.334 4.353 1.17 0 2.266-.461 3.087-1.298l.452.447A4.923 4.923 0 0 1 7.968 20.5C5.228 20.5 3 18.261 3 15.51c0-2.752 2.228-4.99 4.968-4.99a4.98 4.98 0 0 1 4.189 2.311 4.347 4.347 0 0 0 4.1-4.341c0-2.401-1.944-4.353-4.334-4.353-2.39 0-4.334 1.952-4.334 4.353 0 .442.065.877.195 1.294l-.606.189a5.009 5.009 0 0 1-.223-1.483c0-2.752 2.229-4.99 4.968-4.99Zm3.585 12.638c.035.005.348.06.621.444.142.2.153.414.161.555l.002.049c.175-.028.29-.177.322-.225a.226.226 0 0 1 .241-.099c.06.014.16.063.183.232.03.212-.042.912-.514 1.173l-.204-.372c.116-.064.193-.206.241-.349a.795.795 0 0 1-.323.069c-.347 0-.364-.319-.37-.456-.007-.114-.013-.231-.084-.33a.837.837 0 0 0-.087-.107.92.92 0 0 1-.043.224c-.03.101-.079.181-.12.251-.06.099-.094.159-.094.246 0 .163.041.261.271.486l-.295.304c-.258-.252-.398-.453-.398-.79a.85.85 0 0 1 .152-.464.74.74 0 0 0 .08-.159c.032-.102.03-.156.023-.272a3.592 3.592 0 0 1-.006-.2.212.212 0 0 1 .241-.21Zm-7.54-3.349c.117 0 .21.095.21.212 0 .343.31.828.636 1.341.405.636.864 1.358.864 2.044 0 1.267-.886 1.844-1.71 1.844s-1.71-.577-1.71-1.844c0-.686.459-1.408.864-2.044.326-.513.635-.998.635-1.34 0-.118.094-.213.21-.213Zm8.288.122c.047.046.07.11.065.173l-.015.062v.035c.004.107.07.466.702 1.098.249.251.346.472.379.671l.057-.129a.211.211 0 0 1 .326-.08c.03.022.722.593.722 1.614 0 1.026-.833 1.637-1.125 1.77l-.175-.387c.186-.084.877-.567.877-1.383 0-.5-.205-.864-.368-1.074-.272.574-.395.632-.503.62l-.05-.008c-.058-.012-.196-.066-.196-.3 0-.093.007-.179.015-.263.024-.282.038-.453-.258-.75-.515-.518-.72-.907-.79-1.173-.417.25-.788.606-.788.937 0 .282.13.5.235.675.056.095.189.318.13.547a.464.464 0 0 1-.223.288c-.403.238-.682-.139-.787-.28a1.54 1.54 0 0 1-.175-.359c-.143.268-.317.726-.317 1.14 0 .748.703 1.318.833 1.392l-.21.37c-.207-.119-1.046-.804-1.046-1.762 0-.709.419-1.575.672-1.723a.249.249 0 0 1 .255-.006c.074.043.09.093.136.23.038.112.125.375.185.456.164.221.194.203.239.176.01-.006.027-.017.03-.027.005-.022 0-.079-.085-.224-.117-.197-.295-.494-.295-.893 0-.634.708-1.189 1.313-1.472a.21.21 0 0 1 .235.04Zm-8.288.83a9.31 9.31 0 0 1-.49.83c-.392.616-.797 1.253-.797 1.815 0 1.12.809 1.42 1.287 1.42.478 0 1.287-.3 1.287-1.42 0-.562-.405-1.199-.797-1.816a9.31 9.31 0 0 1-.49-.83Zm4.772-8.358c.09.043.137.145.113.242L12.39 7.49h1.013c.08 0 .154.046.19.12a.212.212 0 0 1-.022.222l-2.206 2.888a.21.21 0 0 1-.26.062.212.212 0 0 1-.113-.242l.463-1.864h-1.014a.212.212 0 0 1-.167-.342l2.205-2.888a.211.211 0 0 1 .26-.062Zm-.543 1.131L10.87 8.25h.856c.065 0 .126.03.166.082.04.051.055.118.039.182L11.65 9.65l1.326-1.736h-.856a.212.212 0 0 1-.205-.264l.282-1.136Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }));
});
var FwSet0LandDevelopmentNo = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0LandDevelopmentNo = FwSet0LandDevelopmentNo;